import api from "../../core/api/api";

/* =====================================================
   📦 LIST ORDERS (ADMIN)
===================================================== */
export const listOrders = async (status) => {
  try {
    const res = await api.get("/orders", {
      params: status ? { status } : {}
    });

    return Array.isArray(res.data) ? res.data : [];
  } catch (err) {
    console.error("Failed loading orders:", err?.response || err.message);
    throw new Error("Failed loading orders");
  }
};

/* =====================================================
   📊 ORDER STATS (ADMIN) — accurate counts + revenue
===================================================== */
export const getOrderStats = async () => {
  try {
    const res = await api.get("/orders/stats");
    return res.data || null;
  } catch {
    return null;   // caller falls back to counting the loaded list
  }
};

/* =====================================================
   👤 LIST ORDERS BY CUSTOMER (ADMIN)
===================================================== */
export const listOrdersByCustomer = async (customerId) => {
  try {
    const res = await api.get("/orders", {
      params: { customerId }
    });

    return Array.isArray(res.data) ? res.data : [];
  } catch (err) {
    console.error("Failed loading customer orders:", err?.response || err.message);
    throw new Error("Failed loading customer orders");
  }
};

/* =====================================================
   🔄 UPDATE ORDER STATUS (ADMIN)
===================================================== */
export const updateOrderStatus = async (orderId, status, cancelReason = "") => {
  try {
    const res = await api.patch(`/orders/${orderId}/status`, {
      status,
      ...(cancelReason ? { cancelReason } : {})
    });

    return res.data;
  } catch (err) {
    console.error("Order status update failed:", err?.response || err.message);
    throw new Error("Failed updating order status");
  }
};
